/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ version: NonNullable<unknown> }} Whats_New_TitleInputs */

const en_whats_new_title = /** @type {(inputs: Whats_New_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`New in Dishly ${i?.version}`)
};

const de_whats_new_title = /** @type {(inputs: Whats_New_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Neu in Dishly ${i?.version}`)
};

/**
* | output |
* | --- |
* | "New in Dishly {version}" |
*
* @param {Whats_New_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const whats_new_title = /** @type {((inputs: Whats_New_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Whats_New_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_whats_new_title(inputs)
	return en_whats_new_title(inputs)
});